export const FLAGS = {
  cookieAuthEnabled: {
    key: "tradedesk-cookie-auth",
    defaultValue: false,
  },
} as const
